import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hoverable?: boolean;
  variant?: 'default' | 'outlined' | 'filled';
}

const Card: React.FC<CardProps> = ({ 
  children, 
  className = '', 
  onClick,
  hoverable = false,
  variant = 'default'
}) => {
  const baseStyles = 'rounded-lg transition-all duration-200 overflow-hidden break-words';
  
  const variantStyles = {
    default: 'bg-white shadow-sm border border-gray-100',
    outlined: 'bg-white border border-gray-200',
    filled: 'bg-gray-50 border border-gray-100'
  };

  const hoverStyles = hoverable ? 
    'hover:shadow-lg hover:-translate-y-1 active:shadow-sm active:translate-y-0' : '';

  return (
    <div 
      className={`
        ${baseStyles}
        ${variantStyles[variant]}
        ${hoverStyles}
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      <div className="p-4 sm:p-6">
        {children}
      </div>
    </div>
  );
};

export default Card;